import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d4a844a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_app",
  ref: "createAppModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Create App", -1))
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px\" data-v-9d4a844a><div class=\"stepper-nav ps-lg-10\" data-v-9d4a844a><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\" data-v-9d4a844a><div class=\"stepper-line w-40px\" data-v-9d4a844a></div><div class=\"stepper-icon w-40px h-40px\" data-v-9d4a844a><i class=\"stepper-check fas fa-check\" data-v-9d4a844a></i><span class=\"stepper-number\" data-v-9d4a844a>1</span></div><div class=\"stepper-label\" data-v-9d4a844a><h3 class=\"stepper-title\" data-v-9d4a844a>Details</h3><div class=\"stepper-desc\" data-v-9d4a844a>Name your App</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-9d4a844a><div class=\"stepper-line w-40px\" data-v-9d4a844a></div><div class=\"stepper-icon w-40px h-40px\" data-v-9d4a844a><i class=\"stepper-check fas fa-check\" data-v-9d4a844a></i><span class=\"stepper-number\" data-v-9d4a844a>2</span></div><div class=\"stepper-label\" data-v-9d4a844a><h3 class=\"stepper-title\" data-v-9d4a844a>Frameworks</h3><div class=\"stepper-desc\" data-v-9d4a844a>Define your app framework</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-9d4a844a><div class=\"stepper-line w-40px\" data-v-9d4a844a></div><div class=\"stepper-icon w-40px h-40px\" data-v-9d4a844a><i class=\"stepper-check fas fa-check\" data-v-9d4a844a></i><span class=\"stepper-number\" data-v-9d4a844a>3</span></div><div class=\"stepper-label\" data-v-9d4a844a><h3 class=\"stepper-title\" data-v-9d4a844a>Database</h3><div class=\"stepper-desc\" data-v-9d4a844a>Select the app database type</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-9d4a844a><div class=\"stepper-line w-40px\" data-v-9d4a844a></div><div class=\"stepper-icon w-40px h-40px\" data-v-9d4a844a><i class=\"stepper-check fas fa-check\" data-v-9d4a844a></i><span class=\"stepper-number\" data-v-9d4a844a>4</span></div><div class=\"stepper-label\" data-v-9d4a844a><h3 class=\"stepper-title\" data-v-9d4a844a>Billing</h3><div class=\"stepper-desc\" data-v-9d4a844a>Provide payment details</div></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-9d4a844a><div class=\"stepper-line w-40px\" data-v-9d4a844a></div><div class=\"stepper-icon w-40px h-40px\" data-v-9d4a844a><i class=\"stepper-check fas fa-check\" data-v-9d4a844a></i><span class=\"stepper-number\" data-v-9d4a844a>5</span></div><div class=\"stepper-label\" data-v-9d4a844a><h3 class=\"stepper-title\" data-v-9d4a844a>Release</h3><div class=\"stepper-desc\" data-v-9d4a844a>Review and Submit</div></div></div></div></div>", 1)
const _hoisted_11 = { class: "flex-row-fluid py-lg-5 px-lg-15" }
const _hoisted_12 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "App Name"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your unique app name"
  })
], -1))
const _hoisted_16 = { class: "fv-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Category"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Select your app category"
  })
], -1))
const _hoisted_18 = { class: "fv-row" }
const _hoisted_19 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_20 = { class: "d-flex align-items-center me-2" }
const _hoisted_21 = { class: "symbol symbol-50px me-6" }
const _hoisted_22 = { class: "symbol-label bg-light-primary" }
const _hoisted_23 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "Quick Online Courses"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure is just one SEO")
], -1))
const _hoisted_25 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_26 = { class: "d-flex flex-stack mb-5 cursor-pointer" }
const _hoisted_27 = { class: "d-flex align-items-center me-2" }
const _hoisted_28 = { class: "symbol symbol-50px me-6" }
const _hoisted_29 = { class: "symbol-label bg-light-danger" }
const _hoisted_30 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "Face to Face Discussions"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure is just one aspect")
], -1))
const _hoisted_32 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_33 = { class: "d-flex flex-stack cursor-pointer" }
const _hoisted_34 = { class: "d-flex align-items-center me-2" }
const _hoisted_35 = { class: "symbol symbol-50px me-6" }
const _hoisted_36 = { class: "symbol-label bg-light-success" }
const _hoisted_37 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "Full Intro Training"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "Creating a clear text structure copywriting")
], -1))
const _hoisted_39 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_40 = { "data-kt-stepper-element": "content" }
const _hoisted_41 = { class: "w-100" }
const _hoisted_42 = { class: "fv-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Select Framework"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify your apps framework"
  })
], -1))
const _hoisted_44 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-warning\" data-v-9d4a844a><i class=\"fab fa-html5 text-warning fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>HTML5</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Base Web Projec</span></span></span>", 1)
const _hoisted_46 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<label class=\"d-flex flex-stack cursor-pointer mb-5\" data-v-9d4a844a><span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-success\" data-v-9d4a844a><i class=\"fab fa-react text-success fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>ReactJS</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Robust and flexible app framework</span></span></span><span class=\"form-check form-check-custom form-check-solid\" data-v-9d4a844a><input class=\"form-check-input\" type=\"radio\" name=\"framework\" value=\"2\" data-v-9d4a844a></span></label>", 1)
const _hoisted_48 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-danger\" data-v-9d4a844a><i class=\"fab fa-angular text-danger fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>Angular</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Powerful data mangement</span></span></span>", 1)
const _hoisted_50 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_51 = { class: "d-flex flex-stack cursor-pointer" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-primary\" data-v-9d4a844a><i class=\"fab fa-vuejs text-primary fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>Vue</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Lightweight and responsive framework</span></span></span>", 1)
const _hoisted_53 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_54 = { "data-kt-stepper-element": "content" }
const _hoisted_55 = { class: "w-100" }
const _hoisted_56 = { class: "fv-row mb-10" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, " Database Name ", -1))
const _hoisted_58 = { class: "fv-row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Select Database Engine"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Select your app database engine"
  })
], -1))
const _hoisted_60 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-success\" data-v-9d4a844a><i class=\"fas fa-database text-success fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>MySQL</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Basic MySQL database</span></span></span>", 1)
const _hoisted_62 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_63 = { class: "d-flex flex-stack cursor-pointer mb-5" }
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-danger\" data-v-9d4a844a><i class=\"fab fa-google text-danger fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>Firebase</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Google based app data management</span></span></span>", 1)
const _hoisted_65 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_66 = { class: "d-flex flex-stack cursor-pointer" }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<span class=\"d-flex align-items-center me-2\" data-v-9d4a844a><span class=\"symbol symbol-50px me-6\" data-v-9d4a844a><span class=\"symbol-label bg-light-warning\" data-v-9d4a844a><i class=\"fab fa-amazon text-warning fs-2x\" data-v-9d4a844a></i></span></span><span class=\"d-flex flex-column\" data-v-9d4a844a><span class=\"fw-bolder fs-6\" data-v-9d4a844a>DynamoDB</span><span class=\"fs-7 text-muted\" data-v-9d4a844a>Amazon Fast NoSQL Database</span></span></span>", 1)
const _hoisted_68 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_69 = { "data-kt-stepper-element": "content" }
const _hoisted_70 = { class: "w-100" }
const _hoisted_71 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Name On Card"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1))
const _hoisted_73 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Card Number", -1))
const _hoisted_75 = { class: "position-relative" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 end-0 me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/card-logos/visa.svg",
    alt: "",
    class: "h-25px"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/card-logos/mastercard.svg",
    alt: "",
    class: "h-25px"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/svg/card-logos/american-express.svg",
    alt: "",
    class: "h-25px"
  })
], -1))
const _hoisted_77 = { class: "row mb-10" }
const _hoisted_78 = { class: "col-md-8 fv-row" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Expiration Date", -1))
const _hoisted_80 = { class: "row fv-row" }
const _hoisted_81 = { class: "col-6" }
const _hoisted_82 = ["label", "value"]
const _hoisted_83 = { class: "col-6" }
const _hoisted_84 = ["label", "value"]
const _hoisted_85 = { class: "col-md-4 fv-row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "CVV"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Enter a card CVV code"
  })
], -1))
const _hoisted_87 = { class: "position-relative" }
const _hoisted_88 = { class: "position-absolute translate-middle-y top-50 end-0 me-3" }
const _hoisted_89 = { class: "svg-icon svg-icon-2hx" }
const _hoisted_90 = { class: "d-flex flex-stack" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label" }, "Save Card for further billing?"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " If you need more info, please check budget planning ")
], -1))
const _hoisted_92 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-400" }, " Save Card ", -1))
const _hoisted_94 = /*#__PURE__*/_createStaticVNode("<div data-kt-stepper-element=\"content\" data-v-9d4a844a><div class=\"w-100 text-center\" data-v-9d4a844a><h1 class=\"fw-bolder text-dark mb-3\" data-v-9d4a844a>Release!</h1><div class=\"text-muted fw-bold fs-3\" data-v-9d4a844a> Submit your app to kickstart your project. </div><div class=\"text-center px-4 py-15\" data-v-9d4a844a><img src=\"media/illustrations/sketchy-1/9.png\" alt=\"\" class=\"w-100 mh-300px\" data-v-9d4a844a></div></div></div>", 1)
const _hoisted_95 = { class: "d-flex flex-stack pt-10" }
const _hoisted_96 = { class: "me-2" }
const _hoisted_97 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_99 = { class: "indicator-label" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_101 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_103 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_104 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_105 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("form", {
                class: "form",
                novalidate: "novalidate",
                id: "kt_modal_create_app_form",
                onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "appName",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "appName"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, [
                              _createElementVNode("span", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/maps/map004.svg" })
                                ])
                              ])
                            ]),
                            _hoisted_24
                          ]),
                          _createElementVNode("span", _hoisted_25, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              type: "radio",
                              name: "category",
                              value: "1"
                            })
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, [
                                _createElementVNode("span", _hoisted_30, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                                ])
                              ])
                            ]),
                            _hoisted_31
                          ]),
                          _createElementVNode("span", _hoisted_32, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              type: "radio",
                              name: "category",
                              value: "2"
                            })
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, [
                              _createElementVNode("span", _hoisted_36, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen013.svg" })
                                ])
                              ])
                            ]),
                            _hoisted_38
                          ]),
                          _createElementVNode("span", _hoisted_39, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              type: "radio",
                              name: "category",
                              value: "3"
                            })
                          ])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "category"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("label", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            checked: "",
                            name: "framework",
                            value: "1"
                          })
                        ])
                      ]),
                      _hoisted_47,
                      _createElementVNode("label", _hoisted_48, [
                        _hoisted_49,
                        _createElementVNode("span", _hoisted_50, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "framework",
                            value: "3"
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("span", _hoisted_53, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "framework",
                            value: "4"
                          })
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "framework"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "dbName",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "dbName"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("label", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("span", _hoisted_62, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "dbType",
                            value: "1"
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("span", _hoisted_65, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "dbType",
                            value: "2"
                          })
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_66, [
                        _hoisted_67,
                        _createElementVNode("span", _hoisted_68, [
                          _createVNode(_component_Field, {
                            class: "form-check-input",
                            type: "radio",
                            name: "dbType",
                            value: "3"
                          })
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "dbType"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "",
                        name: "nameOnCard"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "nameOnCard"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "Enter card number",
                          name: "cardNumber"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "cardNumber"
                        }),
                        _hoisted_76
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _hoisted_79,
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createVNode(_component_Field, {
                              name: "cardExpiryMonth",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Month",
                              as: "select"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                                  return _createElementVNode("option", {
                                    key: i,
                                    label: i,
                                    value: i
                                  }, null, 8, _hoisted_82)
                                }), 64))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "cardExpiryMonth"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createVNode(_component_Field, {
                              name: "cardExpiryYear",
                              class: "form-select form-select-solid select2-hidden-accessible",
                              placeholder: "Year",
                              as: "select"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                                  return _createElementVNode("option", {
                                    key: i,
                                    label: i + (new Date().getFullYear() - 1),
                                    value: i
                                  }, null, 8, _hoisted_84)
                                }), 64))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "cardExpiryYear"
                            })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createElementVNode("div", _hoisted_87, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            minlength: "3",
                            maxlength: "4",
                            placeholder: "CVV",
                            name: "cardCvv"
                          }),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "cardCvv"
                          }),
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("span", _hoisted_89, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/finance/fin002.svg" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("label", _hoisted_92, [
                        _createVNode(_component_Field, {
                          type: "checkbox",
                          class: "form-check-input",
                          name: "saveCard",
                          value: "1"
                        }),
                        _hoisted_93
                      ])
                    ])
                  ])
                ]),
                _hoisted_94,
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-light-primary me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previousStep()))
                    }, [
                      _createElementVNode("span", _hoisted_97, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _hoisted_98
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          class: "btn btn-lg btn-primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
                        }, [
                          _createElementVNode("span", _hoisted_99, [
                            _hoisted_100,
                            _createElementVNode("span", _hoisted_101, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                            ])
                          ]),
                          _hoisted_102
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_103, [
                          _hoisted_104,
                          _createElementVNode("span", _hoisted_105, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                  ])
                ])
              ], 32)
            ])
          ], 512)
        ])
      ])
    ])
  ], 512))
}